'use client';

import clsx from 'clsx';
import { CSSProperties, useState } from 'react';
import { CSS_VAR_SCROLL } from '../../constants/css';
import { useScrollOffset } from '../../hooks/scrollOffset';
import { AppScreen } from '../AppScreen/AppScreen';
import styles from './AppScreens.module.scss';

export const AppScreens = () => {
  const [card, setCard] = useState(false);
  const scroll = useScrollOffset();

  const rfidCardClasses = clsx(styles.rfIdCard, {
    [styles['rfidCardVisible']]: card,
  });

  const style = {
    [CSS_VAR_SCROLL]: scroll,
  } as CSSProperties;

  return (
    <div className={styles.base} style={style}>
      <AppScreen
        className={rfidCardClasses}
        delay={200}
        badge={
          <span>
            <strong>Jetzt neu</strong>
            <br />
            verfügbar
          </span>
        }
        screen={'welcome'}
        onAnimationEnd={() => setCard(true)}
      />
      <AppScreen screen={'map'} />
      <AppScreen delay={200} screen={'car'} />
    </div>
  );
};
